module.exports = __webpack_public_path__ + "static/img/tip1.fe27364.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tip1.png
// module id = 873s
// module chunks = 0